import { Box, List, ListItem, makeStyles, Typography } from '@material-ui/core'
import DoneIcon from '@material-ui/icons/Done'
import ArrowForwardIcon from '@material-ui/icons/ArrowForward'
import FlagIcon from '@material-ui/icons/FlagOutlined'

import { SpacedGroup, VisibilitySensor } from 'UI/Components'

const useStyles = makeStyles({
    list: {
        width: '100%',
        padding: 0,
        maxHeight: '35vh',
        overflowY: 'auto'
    },
    baseLine: {
        position: 'relative',
        width: '100%',
        borderRadius: 4,
        height: 5,
        background: 'lightgrey'
    }
})

type Props = {
    stepsProgress: Record<number, number>
    hasCover: boolean
    hasEnd: boolean
}

export const ProgressList = ({ stepsProgress, hasCover, hasEnd }: Props) => {
    const classes = useStyles()

    return (
        <>
            <List className={classes.list}>
                {Object.values(stepsProgress).map((value, idx) => {
                    const isCover = hasCover && idx === 0
                    const isEnd = hasEnd && idx === Object.values(stepsProgress).length - 1

                    const index = (idx + (hasCover ? 0 : 1)).toString().padStart(2, '0')

                    return (
                        <VisibilitySensor
                            key={idx}
                            placeholder={<span>&nbsp;</span>}
                            threshold={0.01}
                            delay={100}
                        >
                            <ListItem>
                                <SpacedGroup spacing={1} width="100%">
                                    <Box
                                        display="flex"
                                        alignItems="center"
                                        justifyContent="center"
                                        bgcolor="#EDEEEF"
                                        minWidth={25}
                                        minHeight={25}
                                        borderRadius="50%"
                                    >
                                        <Typography
                                            variant="body2"
                                            style={{ color: 'rgba(9, 12, 16, 0.6)' }}
                                        >
                                            {isCover && <ArrowForwardIcon fontSize="small" />}
                                            {!isCover && !isEnd && index}
                                            {isEnd && <FlagIcon fontSize="small" />}
                                        </Typography>
                                    </Box>
                                    <Box width="100%">
                                        {value === 100 ? (
                                            <SpacedGroup spacing={0.5}>
                                                <DoneIcon
                                                    fontSize="small"
                                                    style={{ color: '#73CC6D' }}
                                                />
                                                <Typography style={{ fontSize: 14 }}>
                                                    Done!
                                                </Typography>
                                            </SpacedGroup>
                                        ) : (
                                            <Typography
                                                style={{ fontSize: 14, fontStyle: 'italic' }}
                                            >
                                                Typing...
                                            </Typography>
                                        )}
                                        <Box
                                            position="relative"
                                            mt={0.5}
                                            className={classes.baseLine}
                                        >
                                            <Box
                                                position="absolute"
                                                top={0}
                                                left={0}
                                                height="100%"
                                                bgcolor={value === 100 ? 'gray' : 'darkgray'}
                                                width={`${value}%`}
                                                borderRadius={4}
                                            />
                                        </Box>
                                    </Box>
                                </SpacedGroup>
                            </ListItem>
                        </VisibilitySensor>
                    )
                })}
            </List>
        </>
    )
}
